<template>
  <b-card class="col-12" no-body>
    <div class="m-2">
      <b-row>
        <b-col cols="12">
          <h4 class="text-center font-weight-bold">
            DANH SÁCH THUÊ BAO BLACKLIST
          </h4>
        </b-col>
      </b-row>
      <validation-observer ref="modalSearch">
        <div class="p-1">
          <b-row>
            <b-col cols="12" md="3">
              <b-form-group label="Tìm kiếm">
                <b-form-input
                    v-model="serverParams.search"
                    placeholder="Nhập số thuê bao"
                />
              </b-form-group>
            </b-col>
            <b-col class="d-flex justify-content-end align-items-end" cols="12" md="9">
              <b-button class="ml-1" style="height: 42px; margin-bottom: 12px" variant="success" @click="onAddPhone">
                Thêm thuê bao
              </b-button>
              <b-button class="ml-1" style="height: 42px; margin-bottom: 12px" variant="primary" @click="onExportExcel">
                Xuất excel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </validation-observer>
      <b-row>
        <b-col cols="12">
          <vue-good-table
              :columns="fields"
              :isLoading.sync="isLoading"
              :line-numbers="true"
              :pagination-options="{ perPage: serverParams.pageSize, enabled: true }"
              :rows="tableData"
              :sort-options="{
                            enabled: false,
                        }"
              :totalRows="totalRecords"
              class="vpbank-tb-container"
              mode="remote"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-per-page-change="onPerPageChange"
          >
            <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field === 'action'" class="action-container">
                            <b-button
                                class="btn-icon"
                                size="sm"
                                variant="primary"
                                @click="onDelete(props.row)"
                            >
                                <feather-icon icon="TrashIcon"/>
                            </b-button>
                        </span>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </div>
    <b-modal
        id="modalAddPhone"
        :title="'Thêm thuê bao'"
        centered
        hide-footer
        size="sm"
        @hide="$bvModal.hide('modalAddPhone')"
    >
      <template>
        <validation-observer ref="modalInputPhone">
          <b-col cols="12">
            <b-form-group label="Nhập số thuê bao">
              <b-form-input v-model="phone" placeholder="Nhập số thuê bao" size="sm" type="text"/>
            </b-form-group>
          </b-col>
        </validation-observer>
      </template>
      <template scope-slot="modal-footer">
        <div class="group-button-footer pt-1">
          <button class="btn btn-secondary" type="button" @click="$bvModal.hide('modalAddPhone')">
            Cancel
          </button>
          <button class="btn btn-primary" type="button" @click="onAddNewPhone">OK</button>
        </div>
      </template>
    </b-modal>
  </b-card>
</template>
<script>
import {BButton, BCard, BCol, BFormGroup, BFormInput, BModal, BRow} from "bootstrap-vue"
import {VueGoodTable} from "vue-good-table";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import XLSX from 'xlsx';

import "@core/scss/vue/libs/vue-good-table.scss";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    VueGoodTable,
    ValidationProvider,
    ValidationObserver,
    BModal
  },
  data() {
    return {
      totalRecords: 0,
      isLoading: false,
      serverParams: {
        page: 1,
        pageSize: 10,
        search: ""
      },
      tableData: [],
      fields: [
        {
          field: "phone",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Số thuê bao",
          required: true,
          disabled: true,
          tdClass: "text-center",
        },
        {
          field: "action",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Action",
          required: true,
          disabled: true,
          width: "auto",
        },
      ],
      timeOut: null,
      phone: ""
    }
  },
  mounted() {
    this.getTableData();
  },
  watch: {
    serverParams: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.getTableData();
        }, 500);
      },
    },
  },
  methods: {
    onExportExcel() {
      useJwt.post(`blacklist`, {page: 1, pageSize: this.totalRecords}).then(rs => {
        const data = rs.data.result;

        let createXLSLFormatObj = [];

        const columns = this.fields.filter(el => el.field !== "action")

        // let newXlsHeader = [];
        // vm.columns.map(column => {
        //     newXlsHeader.push(column.label);
        // });
        // createXLSLFormatObj.push(newXlsHeader);

        data.map(value => {
          let innerRowData = [];
          columns.map(val => {
            let fieldValue = value[val.field];
            if (val.field.split('.').length > 1) {
              fieldValue = this.getNestedValue(value, val.field);
            }
            if (val.dataFormat && typeof val.dataFormat === 'function') {
              innerRowData.push(val.dataFormat(fieldValue));
            } else {
              innerRowData.push(fieldValue);
            }
          });
          createXLSLFormatObj.push(innerRowData);
        });

        let fileName = "Sheet.xlsx";
        let ws_name = "Sheetname";

        let wb = XLSX.utils.book_new(),
            ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, fileName);
      }).catch(err => {
        console.log("err", err)
      })
    },
    getNestedValue(object, string) {
      string = string.replace(/\[(\w+)\]/g, '.$1');
      string = string.replace(/^\./, '');
      let a = string.split('.');
      for (let i = 0, n = a.length; i < n; ++i) {
        let k = a[i];
        if (k in object) {
          object = object[k];
        } else {
          return;
        }
      }
      return object;
    },
    async getTableData() {
      this.isLoading = true;
      const response = await useJwt.post(`blacklist`, this.serverParams);
      this.isLoading = false;
      if (response.data.code === 200) {
        this.tableData = response.data.result;
        this.totalRecords = response.data.totalRecords;
      } else {
        this.tableData = [];
        this.totalRecords = 0;
      }
    },
    onAddPhone() {
      this.$bvModal.show('modalAddPhone')
    },
    onAddNewPhone() {
      useJwt.get(`add-blacklist?phone=${this.phone}`).then(rs => {
        this.getTableData();
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thêm thành công!",
            icon: "CheckSquareIcon",
            variant: "primary",
          },
        });
        this.$bvModal.hide('modalAddPhone')
      }).catch(err => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thêm không thành công!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.$bvModal.hide('modalAddPhone')
      })
    },
    async onDelete(item) {
      var res = await this.$bvModal.msgBoxConfirm("Bạn có chắc chắn muốn xóa số thuê bao này", {
        title: "Xóa thuê bao",
        size: "sm",
        centered: true
      });

      if (res) {
        const response = await useJwt.get(`dele-blacklist?phone=${item.phone}`);
        if (response.data.code === 200) {
          this.getTableData();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xoá thành công!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xóa không thành công!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
    },
    onSortChange(params) {
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage;
    },
  }
}
</script>
<style lang="scss">
.vpbank-tb-container .line-numbers,
th.vgt-left-align {
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
}

.vpbank-tb-container td {
  height: 34.4px !important;
}

.action-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.action-container button {
  margin: 0 10px;
}

.group-button-footer {
  display: flex;
  justify-content: end;
  gap: 10px;
}
</style>
